import React from 'react';

import { brokerTypes } from './actions'


const initialState = {
    isFetching: false,
}

const adminsInitialState = {
    isFetching: false,
    data: false,
}


export function brokers(state = initialState, action) {

    switch(action.type) {

        case brokerTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case brokerTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.data = action.data

            return state


        default:
            return state
    }
}


export function admins(state = adminsInitialState, action) {

    switch(action.type) {

        case brokerTypes.REQUEST_ADMIN:
            state = {...state}
            state.isFetching = true
            return state

        case brokerTypes.RECEIVE_ADMIN:
            state = {...state, isFetching: false}
            state.data = action.data

            return state


        default:
            return state
    }
}